import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import React from 'react';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';

var DrawerItems = function DrawerItems(_ref) {
  var checkboxItems = _ref.checkboxItems;
  return React.createElement(FormGroup, null, checkboxItems.map(function (item) {
    return React.createElement(FormControlLabel, {
      key: item.itemTitle,
      sx: {
        '.MuiFormControlLabel-label': ASPENDENTAL_FONTS.bodyMediumBook
      },
      control: React.createElement(Checkbox, null),
      label: item.itemTitle
    });
  }));
};

export default DrawerItems;